/* global BeforeUnloadEvent */
import { useEffect } from 'react';

const CLOSE_WARNING_MESSAGE = 'You have an active Dialer call. Leaving this page will end it.';

function useActiveCallCloseWarning(hasActiveCall: boolean) {
  useEffect(() => {
    if (!hasActiveCall) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasActiveCall]);
}

export { CLOSE_WARNING_MESSAGE };
export default useActiveCallCloseWarning;
